import React from 'react'
import { connect } from 'react-redux'
import filter from 'lodash/filter'
import find from 'lodash/find'
import sortBy from 'lodash/sortBy'
import Icon from '../../misc/Icons'
import { formatDate } from '../../../utils/formatDate'
import SearchPathBreadcrumb from '../SearchPathBreadcrumb'
import SearchPreviewChildList from './SearchPreviewChildList'

function SearchPreviewFolder({
  hit, storeFolder, subfolders, sets, questions,
}) {
  const folder = storeFolder || hit
  const editedAt = folder && folder.clientModified
  // The breadcrumb needs `ancestors` present to be read as a folder, and the
  // store entity may not carry them when only the hit does.
  const pathItem = {
    ...folder,
    ancestors: (folder && folder.ancestors) || (hit && hit.ancestors) || [],
  }

  return (
    <div className='searchPreviewPane searchPreviewPane--folder'>
      <div className='searchPreviewPane-header'>
        <div className='searchPreviewPane-header-icon'>
          <Icon name={folder && folder.readOnly ? 'folder-isbe' : 'folder'} />
        </div>
        <div className='searchPreviewPane-header-text'>
          <div className='searchPreviewPane-header-title'>
            {(folder && folder.name) || 'Untitled Folder'}
          </div>
          <SearchPathBreadcrumb item={pathItem} classPrefix='searchPreviewPane-breadcrumb' />
          {editedAt && (
            <div className='searchPreviewPane-header-subtitle'>
              {'Edited '}
              {formatDate(editedAt)}
            </div>
          )}
        </div>
      </div>
      <div className='searchPreviewPane-body searchPreviewFolder'>
        <SearchPreviewChildList
          folders={subfolders}
          sets={sets}
          questions={questions}
          emptyLabel='Folder has no content'
        />
      </div>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.hit && ownProps.hit.id
  if (!id) {
    return {
      storeFolder: null, subfolders: [], sets: [], questions: [],
    }
  }
  const storeFolder = find(state.folders, { id })

  const subfolders = sortBy(
    filter(state.folders, (f) => f && f.parent === id && !f.archived),
    'name',
  )
  const sets = sortBy(
    filter(state.sets, (s) => s && s.folder === id && !s.archived),
    'name',
  )
  const questions = sortBy(
    filter(state.questions, (q) => q && q.folder === id && !q.archived),
    (q) => -((q.clientModified && new Date(q.clientModified).getTime()) || 0),
  )
  return {
    storeFolder, subfolders, sets, questions,
  }
}

export default connect(mapStateToProps)(SearchPreviewFolder)
